<script setup lang="ts">
import { UnorderedListOutlined } from '@ant-design/icons-vue';
import { gql } from 'graphql-tag';
import { GqlQuery } from '~/lib/fw';
import Dashboard from '~/pages/visao-geral/Dashboard.vue';

const gqlQuery = gql`
  query visaoGeralQuery {
    cache(where: { partitionKey: { eq: "visaoGeral" } }) {
      key
      value
    }
  }
`;
</script>

<template>
  <Page :loading="false" menu="visao-geral">
    <div class="visao-geral-page" style="padding-bottom: 24px">
      <a-row>
        <a-col :span="12">
          <h1>
            <UnorderedListOutlined style="color: #bebcbc; font-size: 18px" />
            Visão geral
          </h1>
        </a-col>
      </a-row>
      <a-tabs
        style="margin-top: 8px"
        :destroy-inactive-tab-pane="true"
        :animated="false"
      >
        <a-tab-pane key="1" tab="Pastas">
          <GqlQuery
            :query-key="['visao-geral']"
            :query="gqlQuery"
            :retry="false"
            :remove-cache-on-unmount="true"
          >
            <template #loading>
              <VisaoGeralLoadingSkeleton />
            </template>
            <template #default="{ data, isFetching }">
              <a-spin :spinning="isFetching">
                <Dashboard :data="data.cache" />
              </a-spin>
            </template>
          </GqlQuery>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Compromissos">
          <CompromissoGqlDatatable :enable-row-selection="true" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </Page>
</template>
